import { onDocumentReady, prefersReducedMotion } from '@theme/utilities';
import { getIntersectionRoot, scrollContainerMediaQuery } from '@theme/scroll-container';

const selector = '[data-dizzign-reveal]';
let observer;

function reveal(group) {
  group.classList.add('is-revealed');
  group.addEventListener(
    'transitionend',
    () => group.classList.remove('dizzign-reveal--pending'),
    { once: true }
  );
}

function revealImmediately(group) {
  group.classList.remove('dizzign-reveal--pending');
  group.classList.add('is-revealed');
}

function initialiseGroups(scope = document) {
  const groups = [];

  if (scope instanceof Element && scope.matches(selector)) groups.push(scope);
  if (scope.querySelectorAll) groups.push(...scope.querySelectorAll(selector));

  if (!groups.length) return;

  if (document.documentElement.classList.contains('shopify-design-mode') || prefersReducedMotion()) {
    groups.forEach(revealImmediately);
    return;
  }

  if (!('IntersectionObserver' in window)) {
    groups.forEach(revealImmediately);
    return;
  }

  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(/** @type {HTMLElement} */ (entry.target));
          observer?.unobserve(entry.target);
        });
      },
      { root: getIntersectionRoot(), rootMargin: '0px 0px -10%', threshold: 0.1 }
    );
  }

  groups.forEach((group) => {
    if (group.dataset.dizzignRevealInitialised === 'true') return;
    group.dataset.dizzignRevealInitialised = 'true';
    group.classList.add('dizzign-reveal--pending');
    observer.observe(group);
  });
}

function resetForScrollContainerChange() {
  observer?.disconnect();
  observer = undefined;
  document.querySelectorAll(selector).forEach((group) => {
    if (group.classList.contains('is-revealed')) return;
    group.dataset.dizzignRevealInitialised = '';
  });
  initialiseGroups();
}

onDocumentReady(() => initialiseGroups());
document.addEventListener('shopify:section:load', (event) => initialiseGroups(event.target));
scrollContainerMediaQuery.addEventListener('change', resetForScrollContainerChange);
